import { React, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import AuthService from "../../services/auth.service";
import logo from "../../assets/logo.png";
import ck_success from "../../assets/check-success.gif";

const ResetPasswordSuccess = () => {
  //Navigate
  const navigate = useNavigate();

  useEffect(() => {
    //Auth
    if (AuthService.auth()) {
      navigate("/dashboard");
    }
  }, []);

  return (
    <div className="main d-flex justify-content-center w-100 bg-full-login">
      <main className="content d-flex p-4">
        <div className="container d-flex flex-column">
          <Link to="/" style={{ width: 100 }}>
            <img
              className="img-logo-login d-none d-sm-block"
              src={logo}
              alt="logo"
            />
          </Link>
          <div className="row h-100">
            <div className="col-sm-10 col-md-8 col-lg-8 mx-auto d-table h-100">
              <div className="d-table-cell align-middle">
                <div className="text-center ms-2 me-2 mb-3">
                  <img
                    className="img-logo-login d-md-none d-lg-none"
                    src={logo}
                    alt="logo"
                  />
                </div>
                <div className="card bg-white-transparent rounded-4">
                  <div className="text-center mt-4">
                    <h4 className="h2 text-orange">Reset Password Success</h4>
                  </div>
                  <div className="card-body">
                    <div className="text-center">
                      <img className="mt-3 mb-5" src={ck_success} />
                    </div>
                    <div className="text-center col-md-10 mx-auto">
                      <p className="mb-0">
                        You can now use your Otokata account.
                      </p>
                      <p className="p-0">
                        You can login to your account with new password.
                      </p>
                    </div>
                    <div className="text-center mt-7">
                      <Link to="/login" className="btn btn-lg btn-success">
                        Login
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ResetPasswordSuccess;
